import React, { useState, useRef, useEffect } from "react";

export function ColorSelect({ colors = [], onChange, valueColor }) {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const dropdownRef = useRef(null);

  // Fecha dropdown ao clicar fora
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (color) => {
    onChange && onChange(color.colorId); // só dispara pro pai
    setOpen(false);
    setSelected(color); // só muda visualmente
  };

  useEffect(() => {
    if (valueColor && colors.length > 0) {
      const colorFound = colors.find(
        (c) => String(c.colorId) === String(valueColor)
      );
      setSelected(colorFound || null);
    } else {
      setSelected(null);
    }
  }, [valueColor, colors]);

  return (
    <div ref={dropdownRef} className="combo-box">
      <div
        onClick={() => setOpen(!open)}
        style={{
          backgroundColor: selected?.rgb || "#fff",
          width: "100%",
          height: "100%",
          border: "1px solid #ccc",
          borderRadius: "5px",
          fontSize: "10px",
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
        }}
      >
        {selected?.label || "Selecione"}
      </div>
      {open && (
        <div
          style={{
            position: "absolute",
            top: "55px",
            left: 0,
            width: "100%",
            border: "1px solid #ccc",
            borderRadius: "5px",
            overflow: "hidden",
            zIndex: 1000,
          }}
        >
          {colors.map((color, index) => (
            <div
              key={index}
              onClick={() => handleSelect(color)}
              style={{
                backgroundColor: color.rgb,
                height: "30px",
                cursor: "pointer",
                fontSize: "10px",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
              }}
            >
              {color.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
